module.exports = __webpack_public_path__ + "img/img2.d72678b5.png";